import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const spotTaxDataSchema = z.object({
  /** Record ID, e.g. "1" */
  id: z.string(),
  /** Coin, e.g. "AIBB" */
  coin: z.string(),
  /** e.g. tax type spot, e.g. "Interest" */
  spotTaxType: z.string(),
  /** Quantity, e.g. "6018333.33333333" */
  amount: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Transaction fee, e.g. "0" */
  fee: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Total accounts, e.g. "468575833.33333306" */
  balance: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** When this record was generated Timestamp, e.g. ""1686128884851"" */
  ts: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type SpotTaxData = z.infer<typeof spotTaxDataSchema>
